'use client'

import React, { memo } from 'react'
import Counter from '../Counter'
import { Box, Button, useBreakpointValue } from '@chakra-ui/react'
import styles from './styles.module.css'
import { useSelector } from 'react-redux'
import { IRedux } from '../../_store/types'

interface IProps {
  quantity: number
  isOrdered: boolean
  onClick: () => void
  setQuantity: (e: number) => void
  onRemove: () => void
  children: React.ReactNode
  isDisabled?: boolean
}

function AddToCart({
  onClick,
  quantity,
  setQuantity,
  onRemove,
  isOrdered,
  children,
  isDisabled = false,
}: IProps) {
  const colors = useSelector(
    (state: IRedux) => state.settings?.data?.data?.colors
  )
  const isDesktop = useBreakpointValue(
    { base: false, lg: true },
    { ssr: false }
  )
  // const [count, setCount] = useState(quantity || 1)

  // const debounce = useRef(setTimeout(() => {}, 300))

  // const onIncreaseDebounce = () => {
  //   setCount((prev) => ++prev)
  //   clearTimeout(debounce.current)

  //   debounce.current = setTimeout(() => {
  //     setQuantity(count)
  //   }, 300)
  // }
  // const onDecreaseDebounce = () => {
  //   if (count > 1) {
  //     setCount((prev) => --prev)
  //     clearTimeout(debounce.current)

  //     debounce.current = setTimeout(() => {
  //       setQuantity(count)
  //     }, 300)
  //   } else {
  //     onRemove()
  //     setCount(1)
  //   }
  // }

  const onIncrease = () => {
    setQuantity(quantity + 1)
  }
  const onDecrease = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1)
    } else {
      onRemove()
    }
  }

  let onClickCardHandler = () => {
    // play()
    onClick()
  }

  return (
    <Box w='full' className={styles.svg}>
      {isOrdered ? (
        <Counter
          variable={quantity}
          height={{ base: 10, lg: 12 }}
          onIncrease={onIncrease}
          onDecrease={onDecrease}
          bg={
            isDesktop
              ? 'product_button'
              : colors?.is_advanced
                ? 'product_button'
                : '#fff'
          }
        />
      ) : (
        <Button
          w={'full'}
          rounded={12}
          variant='subtle'
          display={'flex'}
          height={{ lg: 12 }}
          justifyContent={'center'}
          onClick={onClickCardHandler}
          size={{ base: 'md', lg: 'lg' }}
          bg={{
            base: colors?.is_advanced ? 'product_button' : '#fff',
            lg: 'product_button',
          }}
          color='product_button.text'
          _hover={{
            bgColor: 'product_button.hover',
          }}
          disabled={isDisabled}
        >
          {children}
        </Button>
      )}
    </Box>
  )
}

export default memo(AddToCart)
